import { render, staticRenderFns } from "./ListaOrdem.vue?vue&type=template&id=7a8edb74&scoped=true&"
import script from "./ListaOrdem.vue?vue&type=script&lang=js&"
export * from "./ListaOrdem.vue?vue&type=script&lang=js&"
import style0 from "./ListaOrdem.vue?vue&type=style&index=0&id=7a8edb74&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a8edb74",
  null
  
)

export default component.exports